module.exports = __webpack_public_path__ + "media/images/lb/729-5d0ca86d985e1c4750551d1a173c7a40.svg";